<template>
  <b-steps
    :has-navigation="false"
    mobile-mode="compact"
  >
    <b-step-item :label="$t('cart')" :type="cartActive" icon="cart" />
    <b-step-item
      :label="$t('customer')"
      :type="customerActive"
      icon="account"
    />
    <b-step-item :label="$t('payment')" :type="paymentActive" icon="cash" />
  </b-steps>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import VueI18n from "vue-i18n";

// Import specific Buefy components
import { Steps } from 'buefy'
import Vue from "vue";
Vue.use(Steps);

export default {
  name: "CartSteps",
  mixins: [LocaleMixin],
  props: {
    step: String
  },

  data () {
    return {
      cartActive: "",
      customerActive: "",
      paymentActive: ""
    };
  },

  beforeMount () {
    if (this.step === "product") {
      this.cartActive = "is-active";
    } else if (this.step === "customer") {
      this.cartActive = "is-active";
      this.customerActive = "is-active";
    } else if (this.step === "payment") {
      this.cartActive = "is-active";
      this.customerActive = "is-active";
      this.paymentActive = "is-active";
    }
  },

  // Translate component
  mounted () {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        cart: "My cart",
        customer: "My information",
        payment: "Payment"
      },
      fr: {
        cart: "Mon panier",
        customer: "Mes informations",
        payment: "Paiement"
      }
    }
  })
};
</script>
